<template>
  <div>
    <!-- PERSONAL INFORMATION -->
    <div>
      <p class="font-weight-medium text-left">Personal Information</p>
      <v-form>
        <v-container>
          <v-row>
            <v-col cols="12" md="9">
              <v-file-input
                dense
                v-model="files"
                color="primary"
                counter
                label="Click here to Upload Picture"
                prepend-icon="mdi-paperclip"
                outlined
                :show-size="1000"
              >
                <template v-slot:selection="{ index, text }">
                  <v-chip v-if="index < 2" color="primary" dark label small>
                    {{ text }}
                  </v-chip>
                  <span
                    v-else-if="index === 2"
                    class="overline grey--text text--darken-3 mx-2"
                  >
                    +{{ files.length - 2 }} File(s)
                  </span>
                </template>
              </v-file-input>
            </v-col>
            <v-col cols="12" md="3">
              <v-img
                :src="`https://picsum.photos/500/300?image=${n * 5 + 10}`"
                :lazy-src="`https://picsum.photos/10/6?image=${n * 5 + 10}`"
                aspect-ratio="1"
                height="200px"
                width="150px"
                class="grey lighten-2"
              ></v-img>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="First Name"
                placeholder="Placeholder"
                outlined
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Middle Name"
                placeholder="Placeholder"
                outlined
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Last Name"
                placeholder="Placeholder"
                outlined
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Father's Name"
                placeholder="Placeholder"
                outlined
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Mother's Name"
                placeholder="Placeholder"
                outlined
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-select
                :items="items"
                label="Gender"
                placeholder="Placeholder"
                outlined
                dense
              ></v-select>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
    <!-- CONTACT INFORMATION -->
    <div>
      <p class="font-weight-medium text-left">Contact Information</p>
      <v-form>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Phone number"
                placeholder="+91 XXXXXXXXXX"
                outlined
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Alternate Number"
                placeholder="Placeholder"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Email*"
                placeholder="XYZ@gmail.com"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>

    <!-- ACADEMIC INFORMATION -->

    <div>
      <p class="font-weight-medium text-left">Academic Information</p>
      <v-form>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Standard of Admission"
                placeholder="1st Standard"
                outlined
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Batch"
                placeholder="2020-2021"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>

    <!-- ACADEMIC HISTORY-->
    <div>
      <p class="font-weight-medium text-left">Academic History</p>
      <v-form>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Previous School. (optional)"
                placeholder="+91 XXXXXXXXXX"
                outlined
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Previous Std. (optional)"
                placeholder="Placeholder"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Previous Std Percentage. (optional)"
                placeholder="XYZ@gmail.com"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>

    <!-- Other Info-->
    <div>
      <p class="font-weight-medium text-left">Other Information</p>
      <v-form>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Handicapped?"
                placeholder="Yes/No"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>

    <!-- BIRTH AND NATIONALITY INFORMATION -->
    <div>
      <p class="font-weight-medium text-left">
        Birth & Nationality Information
      </p>
      <v-form>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Date of bith"
                placeholder="DD/MM/YYYY"
                outlined
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Place of birth"
                placeholder="eg Mumbai"
                outlined
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Nationality"
                placeholder="eg. Indian"
                outlined
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Adhar Number"
                placeholder="XXXX XXXX XXXX XXXX"
                outlined
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Mother Tongue"
                placeholder="Placeholder"
                outlined
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Religion"
                placeholder="Placeholder"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Caste"
                placeholder="Placeholder"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>

    <!-- BIRTH AND NATIONALITY INFORMATION -->
    <div>
      <p class="font-weight-medium text-left">Address Information</p>
      <v-form>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="8">
              <v-text-field
                label="Address (House no. / Street / Lane)"
                placeholder=""
                outlined
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Landmark (Area)"
                placeholder=""
                outlined
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="District"
                placeholder="eg Thane"
                outlined
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="State"
                placeholder="eg Maharashtra"
                outlined
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Pincode"
                placeholder="eg 400612"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
  </div>
</template>

<script>
export default {
  name: "ApplicationStepperContent",

  data: () => ({
    items: ["Male", "Female", "Other"]
  })
};
</script>

<style>
</style>